import React, { Component } from 'react';
import Addmore from '../../components/Addmore';
import * as Common from '../../helpers/Common';
import * as Config from '../../config/Config';
const $= window.$;


class IseekCreateform extends Component {
	constructor(props) {
		super(props);
		this.state={

		};

	this.submit = this.submit.bind(this);
	}


	renameInput(type=""){
		setTimeout(function(){

			$('div[id^="Questions"]').each(function(){
				let mainid=$(this).attr('id').split("_");

				if($('#Questions_'+mainid[1]).find(".dummy_text_select")){
					$('#Questions_'+mainid[1]).find(".dummy_text_select").attr("name",'snap_poll_type['+mainid[1]+']').removeClass('dummy_text_select');

				}

				if($('#Questions_'+mainid[1]).find(".dummy_text_parent")){
					$('#Questions_'+mainid[1]).find(".dummy_text_parent").attr("name",'snap_poll_question['+mainid[1]+']').removeClass('dummy_text_parent');

				}

				if($('#Questions_'+mainid[1]).find(".dummy_text")){
					$('#Questions_'+mainid[1]).find(".dummy_text").attr("name",'snap_poll_answer['+mainid[1]+'][]').removeClass('dummy_text');
					// $('#Questions_'+mainid[1]).find('.answers_input').append('<input type="text" name="snap_poll_answer['+mainid[1]+'][]" class="txtbox"  />');
				}

				if($('#Questions_'+mainid[1]).find(".addanswers")){
					$('#Questions_'+mainid[1]).find(".addanswers").attr("id",mainid[1]).removeClass('addanswers');

				}

			});
		},200);
	}


	submit(e){
		 Common.reactLoader("show", "Please wait...");
		//let learnerID = Common.getUserData("id", true);
		let formData = new FormData();
	    let snap_poll_add_new_form=$('#snap_poll_add_new_form').serializeArray();

	    let details = [];
	       snap_poll_add_new_form.map((key,index)=>{
	           details.push({[key.name]:key.value});
	           formData.append(key.name,key.value);
	       });

	       //alert(JSON.stringify(details));
	       fetch(Config.domainUrl +"personal", {
	        method: "POST",
	        //data: formData,

	       headers: {
	           'Accept': 'application/json',
			   'Authorization':'Bearer ' +Common.getTokenData()
	           //'Content-Type': 'application/json'
	          },
	        body: formData,
	       }).then((response) => response.json()).then((responseJson) => {
	       	 Common.reactLoader("hide");
	       	 
	       		 if (responseJson.status == 0) {
			        Common.message(responseJson.message, responseJson.errors, "error");
			      } else {
			        Common.message("", 'You have created a new feedback form. You can choose to send it to persons of your choice from below.', "success");
			        $('form#snap_poll_add_new_form')[0].reset();
			        $("#savedform").click();
			      }
	       });

	}





	getQuestype(e){
		// var div = this.refs.node.parentNode.parentNode.id;
		// //alert("#"+div+" #cmbPollQuestionType");
		// let id = div.split('_');
		// id= id[1];
		// id="cmbPollQuestionType"+id;
		var qtype = document.querySelectorAll('.qtype');

		var ansdiv = document.querySelectorAll('.ansdiv');
		// Set their ids
		for (var i = 0; i < qtype.length; i++)
		    qtype[i].id = 'cmbPollQuestionType_' + i;

		for (var i = 0; i < ansdiv.length; i++)
		    ansdiv[i].id = 'PollAnswertr_' + i;


		var id = e.target.id;
		var ansid = id.split('_');
		ansid = ansid[1];
		if($("#"+id).val()==2){
			$("#PollAnswertr_"+ansid).hide();
            //$("#PollAnswertr_"+ansid +' :input').attr('disabled',true);

		}
		else{
			$("#PollAnswertr_"+ansid).show();
            // $("#PollAnswertr_"+ansid +' :input').removeAttr('disabled');

		}


	}

	 componentDidMount() {

	 	var qtype = document.querySelectorAll('.qtype');
		var ansdiv = document.querySelectorAll('.ansdiv');

		// Set their ids
		for (var i = 0; i < qtype.length; i++)
		    qtype[i].id = 'cmbPollQuestionType_' + i;

		for (var i = 0; i < ansdiv.length; i++)
		    ansdiv[i].id = 'Poll_Answer_tr' + i;

		


	}


		render() {
				let learnerID = Common.getUserData("id", true);
				let date = new Date();

			return (

				<div className="acc_content_poll">
		            <form id="snap_poll_add_new_form" name="snap_poll_add_new_form" >
		            	<div className="gradientbg gradientbg1">
			              <label>Form Title</label>
			              	<input type="hidden"  name="created_date" value={date} format="Y-m-d"/>
			              	<input type="hidden"  name="lr_id" value={learnerID}/>
			                <input type="text" maxLength="255" name="snap_poll_title" id="txtPollTitle" className="snap_textbox"  />
			            </div>
			            <div className="fdbk-content" id="Main_Question_div">
			            	<Addmore selector="Questions" limit={6} AddLabel="+ Add Questions" DeleteLabel="X" compType="parent" editType="form" refreshScroll={e=>this.renameInput(e)} >
				              	<div className="graybox" id="question1">
					                <div className="fdback-left" >
						                <ul>
						                    <li>
						                        <label>Question type</label>
						                        <div className="input-cntrl">
						                          <select name="snap_poll_type[0]"  className="qtype dummy_text_select"  onChange={(e)=>this.getQuestype(e)}>
						                            <option value="1">Multiple choice question</option>
						                            <option value="2">Open ended question</option>
						                          </select>
						                        </div>
						                    </li>
						                    <li>
						                        <label>Question</label>
						                        <div className="input-cntrl">
						                          <input type="text" maxLength="255" name="snap_poll_question[0]" id="txtPollQuestion" className="snap_textbox dummy_text_parent" />
						                        </div>
						                    </li>
						                </ul>
					                </div>
					                <div className="fdbk-right ansdiv" >
					                  <ul id="Main_answer_div1">
					                    <li id="answer_div11">
					                      <label>Answer Choices</label>
											<div className="input-cntrl addanswers" id="0">
						                     	<Addmore selector="answers" limit={4} AddLabel="+ Add Choices" DeleteLabel="X" compType="child" editType='form' refreshScroll={e=>this.renameInput(e)} parent="Questions" >
													
									                <input name="snap_poll_answer[0][0]" className="txtbox dummy_text"  type="text"/>
													

										    	</Addmore>
											</div>
					                    </li>
					                  </ul>
					                </div>
				              	</div>
			              	</Addmore>
			            </div>
			            <div className="feedback-btns">
			                <div className="fdbk-btn">
			                  <input type="button" name="btnSubmit" id="" value="Save" alt="Save" title="Save" className="button-accept" onClick={e=>this.submit(e)}/>
			                </div>
			            </div>

			        </form>
		        </div>

			);
		}
}

export default IseekCreateform;



// WEBPACK FOOTER //
// ./src/personal_interactions/iseek/IseekCreateform.js